import { MatDialogConfig } from '@angular/material/dialog';

// Telas compactas: celular em pé (< 600px) ou deitado (pouca altura).
// Nelas, diálogos centralizados ficam apertados e brigam com o teclado virtual.
const COMPACT_QUERY = '(max-width: 599.98px), (max-height: 499.98px)';

export function isCompactViewport(): boolean {
    return typeof window !== 'undefined' && window.matchMedia(COMPACT_QUERY).matches;
}

/**
 * Config de MatDialog para conteúdo `.oa-sheet` (ver src/orca-ds.scss).
 * - web: diálogo centralizado com a largura pedida;
 * - telas compactas: `fullscreen` (formulários e seletores com busca) ou
 *   `sheet` (bottom sheet, para opções curtas e configurações).
 */
export function oaDialogConfig<D = any>(
    mode: 'fullscreen' | 'sheet',
    config: MatDialogConfig<D> & { width?: string } = {},
): MatDialogConfig<D> {
    const extraClasses = toArray(config.panelClass);

    if (!isCompactViewport()) {
        return {
            maxWidth: 'calc(100vw - 32px)',
            maxHeight: 'calc(100vh - 32px)',
            ...config,
            panelClass: ['oa-dialog', ...extraClasses],
        };
    }

    const compact: MatDialogConfig<D> = {
        ...config,
        width: '100vw',
        maxWidth: '100vw',
        panelClass: [mode === 'fullscreen' ? 'oa-dialog--fullscreen' : 'oa-dialog--sheet', ...extraClasses],
    };

    if (mode === 'fullscreen') {
        compact.height = '100%';
        compact.maxHeight = '100%';
    } else {
        compact.position = { bottom: '0' };
    }

    return compact;
}

function toArray(value: string | string[] | undefined): string[] {
    if (!value) {
        return [];
    }
    return Array.isArray(value) ? value : [value];
}
